import React from 'react';
import IntroSection from '../components/IntroSection';
import FintechSolutionsSection from '../components/FintechSolutionsSection';
import BlueSectionDivider from '../components/BlueSectionDivider';
import FinBenefits from '../components/FinBenefits';
import CountriesSection from '../components/CountriesSection';
import TechStackSection from '../components/TechStackSection';

import FintechFaq from '../components/FintechFaq';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const Fintech=()=>{
    return (
        <div>
            <IntroSection title ="FINTECH SOLUTIONS" paragraph="Build and scale your finance platforms with innovative fintech solutions" backgroundImage="/images/fintech-bg.webp"/>
            
            <FintechSolutionsSection/>
            <BlueSectionDivider/>
            <FinBenefits imageSrc="https://cdn.prod.website-files.com/63d3b504212f2224c6e39423/65830ca3bdbcd77576dee450_Technical%20consultancy%20fintech.png"/>
            <BlueSectionDivider/>
            <CountriesSection/>
            <BlueSectionDivider/>
            <TechStackSection/>
            <BlueSectionDivider/>
            <FintechFaq/>
           <ContactSection backgroundColor="#057af0ff"/>
            <Footer/>


        </div>
    )
}
export default Fintech;